import createCalculateDecorator from 'final-form-calculate';
import {
  TripType,
  CancellationClaimAmount,
} from '@qover-private/protos-web/qover/dojo/travel/v1/terms';
import {
  calculateBillingAddress,
  calculatePolicyholder,
  focusOnError,
  updateCountry,
} from '@qover/organisms';

import { maxAdults, maxChildren } from './trConstants';

export const calculateTerms = createCalculateDecorator({
  field: 'terms.tripType',
  updates: {
    startDate: (tripType, allValues: any) =>
      tripType === TripType.TRIP_TYPE_SINGLE_TRIP
        ? allValues?.startDate
        : undefined,
    endDate: (tripType, allValues: any) =>
      tripType === TripType.TRIP_TYPE_SINGLE_TRIP
        ? allValues?.endDate
        : undefined,
    'terms.familySituation': (tripType, allValues: any) =>
      tripType === TripType.TRIP_TYPE_SINGLE_TRIP
        ? undefined
        : allValues?.terms?.familySituation,
    'terms.variant': (tripType, allValues: any) =>
      tripType === TripType.TRIP_TYPE_SINGLE_TRIP ||
      tripType === TripType.TRIP_TYPE_YEAR_TRIP
        ? undefined
        : allValues?.terms?.variant,
    'terms.geographicalArea': (tripType, allValues: any) =>
      tripType === TripType.TRIP_TYPE_SINGLE_TRIP
        ? allValues?.terms?.geographicalArea
        : undefined,
    'terms.tripDuration': (tripType, allValues: any) =>
      tripType === TripType.TRIP_TYPE_SINGLE_TRIP
        ? allValues?.terms?.tripDuration
        : undefined,
    'risk.adultsList': (tripType, allValues: any) =>
      tripType === TripType.TRIP_TYPE_SINGLE_TRIP
        ? allValues.risk?.adultsList
        : allValues.risk?.adultsList?.filter(
            (_: any, idx: number) =>
              idx < maxAdults[TripType.TRIP_TYPE_MULTI_TRIP],
          ),
    'risk.childList': (tripType, allValues: any) =>
      tripType === TripType.TRIP_TYPE_SINGLE_TRIP
        ? allValues.risk?.childList
        : allValues.risk?.adultsList?.filter(
            (_: any, idx: number) =>
              idx < maxChildren[TripType.TRIP_TYPE_MULTI_TRIP],
          ),
  },
});

export const calculateTermsCancellationClaimAmount = createCalculateDecorator({
  field: 'terms.hasCancellationTrip',
  updates: {
    'terms.cancellationClaimAmount': (hasCancellationTrip, allValues: any) => {
      if (hasCancellationTrip) {
        return !allValues?.terms?.cancellationClaimAmount
          ? CancellationClaimAmount.CANCELLATION_CLAIM_AMOUNT_1K
          : allValues?.terms?.cancellationClaimAmount;
      }

      return undefined;
    },
  },
});

export const trDecorators = () => [
  calculateBillingAddress,
  calculatePolicyholder,
  calculateTerms,
  calculateTermsCancellationClaimAmount,
  focusOnError,
  updateCountry,
];
